import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import PrimaryButton from '../ui/PrimaryButton';

const { FiSearch, FiDollarSign, FiSmartphone } = FiIcons;

export default function Step1Lookup({ onSubmit }) {
  const [carrier, setCarrier] = useState('Verizon');
  const [amount, setAmount] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (amount) onSubmit({ carrier, amount });
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="card-premium">
      <div className="text-center mb-10">
        <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiSmartphone} className="w-8 h-8 text-blue-600" />
        </div>
        <h2 className="text-4xl font-black text-slate-900 mb-3">Carrier Lookup</h2>
        <p className="text-lg text-slate-500">Let's find out exactly what it takes to break free.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="space-y-3">
          <label className="text-sm font-bold text-slate-700 uppercase tracking-wider ml-1">Current Carrier</label>
          <select
            value={carrier}
            onChange={(e) => setCarrier(e.target.value)}
            className="input-premium appearance-none cursor-pointer"
          >
            <option>Verizon</option>
            <option>AT&T</option>
            <option>T-Mobile</option>
            <option>Other</option>
          </select>
        </div>

        <div className="space-y-3">
          <label className="text-sm font-bold text-slate-700 uppercase tracking-wider ml-1">Estimated Payoff Amount</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
              <SafeIcon icon={FiDollarSign} className="h-6 w-6 text-slate-400" />
            </div>
            <input
              type="number"
              required
              min="1"
              className="input-premium pl-14 text-xl font-bold"
              placeholder="0.00"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <p className="text-xs text-slate-400 ml-1 italic">
            Check your carrier app for your "Device Buyout" balance.
          </p>
        </div>

        <PrimaryButton type="submit" className="w-full py-5 text-xl">
          <SafeIcon icon={FiSearch} className="w-6 h-6" />
          Check Eligibility
        </PrimaryButton>
      </form>
    </motion.div>
  );
}